export const SkeletonProductCard = () => {
  return (
    <div className="relative group border rounded-sm flex flex-col justify-between p-1 w-full lg:w-[calc(25%-1rem)] min-w-[250px] bg-gray-200 animate-pulse h-[338px]" data-testid="skeleton-product-card" />
  )
}
